// src/Pages/Usuario/Home.jsx
import React, { useEffect, useRef, useState } from "react";
import { Page } from "../../components/ui/animations";
import Hero from "../../components/Hero";
import ComoTrabajamos from "../../components/ui/ComoTrabajamos";
import Partners from "../../components/ui/Partners";
import Deportistas from "../../components/ui/Deportistas";

import HomeSplash from "../../components/HomeSplash";

const MIN_SPLASH_MS = 1000;   // mínimo visible (1s)
const MAX_WAIT_MS = 6000;     // máximo espera (por si falla algo)

const Home = () => {
  const [loadingHome, setLoadingHome] = useState(true);

  const startRef = useRef(Date.now());
  const heroReadyRef = useRef(false);
  const mountedRef = useRef(true);

  const hideSplash = async () => {
    if (!mountedRef.current) return;

    // respeta mínimo 1s
    const elapsed = Date.now() - startRef.current;
    const wait = Math.max(0, MIN_SPLASH_MS - elapsed);
    if (wait) await new Promise((r) => setTimeout(r, wait));

    if (mountedRef.current) setLoadingHome(false);
  };

  useEffect(() => {
    mountedRef.current = true;
    startRef.current = Date.now();
    setLoadingHome(true);

    // Failsafe: aunque nunca llegue onHeroReady, se apaga igual
    const t = setTimeout(() => {
      if (!heroReadyRef.current) {
        heroReadyRef.current = true;
        hideSplash();
      }
    }, MAX_WAIT_MS);

    return () => {
      mountedRef.current = false;
      clearTimeout(t);
    };
  }, []);

  return (
    <>
      <HomeSplash show={loadingHome} topOffset={0} zIndex={9999} />

      <Page className="min-h-screen">
        <div className={loadingHome ? "opacity-0" : "opacity-100 transition-opacity duration-500"}>
          <Hero
            onHeroReady={() => {
              if (heroReadyRef.current) return;
              heroReadyRef.current = true;
              hideSplash();
            }}
          />
          <ComoTrabajamos />
          <Partners />
          <Deportistas />
        </div>
      </Page>
    </>
  );
};

export default Home;
